import React from "react";
import { WithFieldValue, DocumentData } from "firebase/firestore";
import { Alert, Text } from "@chakra-ui/react";

import { PRODUCTION_STEPS_AUX } from "@constants";
import { useCustomToast } from "@hooks";

import {
  JsonForm,
  JsonFormControl,
  makeCommentsControl,
  makeDestinationSelectControl,
} from "../JsonForm";
import { ButtonModal } from "../ModalWrappers";
import { useAddAuxStep } from "./useAddAuxStep";

type ShipModuleModalProps = {
  itemId: string;
};

function makeShipControl() {
  return [
    makeDestinationSelectControl(
      "Shipping destination (Note: you should not need to do this step if you are following the normal shipping procedure. Only do this if an additional shipping step is needed.",
      "destination",
    ),
    makeCommentsControl(),
  ] as JsonFormControl[];
}

export function ShipModuleModal({ itemId }: ShipModuleModalProps) {
  const shipFormControl = React.useMemo(() => makeShipControl(), []);
  const addShipToast = useCustomToast(() => (
    <Alert status="success">Shipping complete!</Alert>
  ));
  const [error, setError] = React.useState("");
  const addStep = useAddAuxStep(
    itemId,
    PRODUCTION_STEPS_AUX.STEP_AUX_SHIP_MODULE,
    addShipToast,
    setError,
  );
  const doSubmit = React.useCallback(
    async function <T extends WithFieldValue<DocumentData>>(data: T) {
      const comments = data.comments ? (data.comments as string) : "";
      //const details = { destination: data.destination},

      addStep(comments, { destination: data.destination });
    },
    [addStep],
  );

  return (
    <ButtonModal label="Ship Module" title="Ship Module" size="sm">
      <JsonForm fields={shipFormControl} onSubmit={doSubmit} clearAfterSubmit />
      {error ? <Text>{error}</Text> : undefined}
    </ButtonModal>
  );
}
